<template>
  <div class="sale-page">
    <PaymentForm />
  </div>
</template>
<script>
// Components
import PaymentForm from '@/components/common/PaymentForm/PaymentForm.vue';
export default {
  name: 'SalePage',
  components: {
    PaymentForm
  }
};
</script>
